import * as tslib_1 from "tslib";
import { lazyAddFileProvider } from 'owa-filepicker-add-fileprovider';
var addFileProvider = null;
// Importing it here because addAndSelectFileProvider needs to call the addFileProvider in the same context as the event
// that triggered it. This is done to ensure that popup blocker does not get invoked.
export function initAddFileProvider() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            lazyAddFileProvider.import().then(function (func) { return (addFileProvider = func); });
            return [2 /*return*/];
        });
    });
}
// If the addFileProvider function was loaded early then return that so that
// the popup blocker does not get invoked else we load it and return it
// which will invoke the popup blocker but that is much less likely to happen.
export function getAddFileProvider() {
    return addFileProvider
        ? { isAsync: false, result: addFileProvider }
        : { isAsync: true, result: lazyAddFileProvider.import() };
}
//# sourceMappingURL=lazyAddFileProviderHelper.js.map